import { Typography } from "antd"

import { statusTextMap } from "../../utils/constants"

import styles from "./StatusTagSimple.module.less"

const { Text } = Typography

const StatusTagSimple = ({ status }) => {
  const statusClass = status ? styles[status] : ""
  return (
    <div className={`${styles.tag} ${statusClass}`}>
      <Text className={styles.text}>{statusTextMap[status] || status}</Text>
    </div>
  )
}

export default StatusTagSimple
